export default __webpack_public_path__ + "c219d66c0b7da7f5bbd0362fd5f48b83.jpeg";